import { Flex } from '@chakra-ui/react'
import React, { useState, useEffect, useRef } from 'react'

import Frame from 'react-frame-component';
import { useGetState } from '../../context/useGetState';
import { photoBaseURL } from '../../service/api';

const CreateMeetingIframe = () => {

  const { state } = useGetState();
  const userInfo = state?.userInfo;
  const userImg = userInfo?.picture
  const username = userInfo?.username
  const iframeRef = useRef(null);

  return (

    <>
      <Flex
        w="100%"
        h="100vh"
        align={"center"}
        justify="center"
      >
          <iframe
          ref={iframeRef} 
          src={`https://meet.pindogo.com/newroom?username=${encodeURIComponent(username)}&userImg=${encodeURIComponent(userImg)}`}
          allow="camera; microphone; display-capture; fullscreen; clipboard-read; clipboard-write; autoplay" 
          style={{ width: '105%', height: '100%', border: '0px', marginLeft: '-25px', marginRight: '-10px', marginTop: '-45px' }}
          ></iframe>
      </Flex>
    </>
  )
}

export default CreateMeetingIframe